'use strict';

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    PropTypes = React.PropTypes,
    mui = require('material-ui'),
    ContentUtils = require('utils/ContentUtils'),
    ComponentUtils = require('utils/ComponentUtils'),
    Constants = require('constants/AppConstants'),
    set = require('lodash/object').set,
    get = require('lodash/object').get,
    {find} = require('lodash/collection'),
    {union} = require('lodash/array'),
    BasicFormGroup = require('../BasicFormGroup'),
    {SelectField} = mui;

const FormGroupDropdown = React.createClass({displayName: "FormGroupDropdown",

    propTypes: Object.assign({}, BasicFormGroup.propTypes, {
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        outputMapper: PropTypes.object,
        isImmutable: PropTypes.bool,
        isEditMode: PropTypes.bool,
        onEnter: PropTypes.func,

        // Input fields ------------------------

        /**
         * The list of items which will be used to generate the MenuItem
         */
        items: PropTypes.array.isRequired,

        /**
         * This attribute are several proposes. For instance:
         * As a `displayName` of given Menu item list ({@link items}).
         * Also is used this attribute to read each menu item of Dropdown attribute, when
         * need to know which menu item are selected.
         */
        readerAttribute: PropTypes.string,

        /**
         * This attribute will be use against to {@link value} props to retrieve the
         * information needed from outside selected value. Will be use to match outer
         * value which internal menu item.
         */
        readerAttributeValue: PropTypes.string,

        // Output field ------------------------

        /**
         * This is attribute will use to write the name of the attribute when submit the form.
         * (Optionally) When it doesn't defined we will use by default {@link readerAttribute}
         */
        writerAttribute: PropTypes.string,

        /**
         * This attribute allow us to specify the field will take at the moment
         * to write the value of selected item.
         */
        customReaderWriterAttribute: PropTypes.string,

        /**
         * Is the value which are selected from outside of menu item. So we need to use
         * {@link readerAttributeValue} in order to know which MenuItem
         * are related to this outer `value`, specially when need to know which index of menu item
         * are need to be selected.
         */
        value: PropTypes.string,
        
        /**
         * Indicate that special character validation will not be performed.
         */
        isRelaxedText: PropTypes.bool,
        /**
         * Indicate that special character validation will not be performed.
         */
        isFullRelaxedText: PropTypes.bool

    }),

    getInitialState() {
        return {
            selectedMenuItemIndex: 0,
            selectedMenuItem: null,
            selectedMenuItemIndexConsumer: -1,
            resetSelection: false
        };
    },

    componentDidMount() {
        const {operationsHolder} = this.props;
        // React will throw a warning for bind the context with each operation, but we need it, otherwise
        // we don't have access to the context of the component when need to perform each operation.
        operationsHolder.addValidator(this.isValid.bind(this));
        operationsHolder.addCleaner(this.clean.bind(this));
        operationsHolder.addItemProvider(this.getValue.bind(this));
    },

    clean() {
        this.setState({
            selectedMenuItemIndex: 0,
            selectedMenuItem: null,
            selectedMenuItemIndexConsumer: -1,
            resetSelection: true,
            isFocus: false
        });
    },

    getValue() {
        const {writerAttribute, outputMapper, readerAttribute, customReaderWriterAttribute} = this.props;
        const currentValue = this._getSelectedMenuItemValue(readerAttribute, customReaderWriterAttribute);

        let wrapper = {};
        let safeWriterAttribute = writerAttribute || readerAttribute; // make writer attribute optionally

        if (outputMapper) {
            const keyOutput = outputMapper[currentValue];
            wrapper = set(wrapper, safeWriterAttribute, keyOutput);
        } else {
            wrapper = set(wrapper, safeWriterAttribute, currentValue);
        }

        return wrapper;
    },

    _updateWithOnBlurSelected(callback) {
        if (this.refs && this.refs.dropdownEl) {
            const currentItemSelectedEl = this.refs.dropdownEl.getDOMNode().querySelector('.form-group-dropdown-input div');

            const haveItemSelected = currentItemSelectedEl && currentItemSelectedEl.innerText;
            const haveItemsDefined = ContentUtils.isNotEmptyArray(this.props.items);

            if (haveItemSelected && haveItemsDefined) {
                const itemSelectedText = currentItemSelectedEl.innerText.trim();
                const itemSelectedIndex = this._getIndexOfMenuItem(itemSelectedText);

                this.setState({
                    selectedMenuItem: {payload: itemSelectedIndex, text: itemSelectedText, itemModel: itemSelectedText},
                    selectedMenuItemIndex: itemSelectedIndex,
                    isFocus: false
                }, () => {
                    if (callback) {
                        callback();
                    }
                });
            }
        } else {
            if (callback) {
                callback();
            }
        }
    },

    _getIndexOfMenuItem(textTarget) {
        const isMenuItemObject = typeof this.props.items[0] === 'object';
        const isMenuItemNumber = typeof this.props.items[0] === 'number';
        let menuItemTexts;

        if (isMenuItemObject) {
            menuItemTexts = this.props.items.map(item => get(item, 'name', get(item, 'description', get(item, this.props.readerAttribute))));
        } else if (isMenuItemNumber) {
            menuItemTexts = this.props.items;
            return menuItemTexts.indexOf(+textTarget) + 1;
        } else {
            menuItemTexts = this.props.items;
        }

        if (menuItemTexts) {
            return menuItemTexts.indexOf(textTarget) + 1;
        }
    },

    isValid() {
        let {name, additionalValidation, additionalValidationFieldName, isRequired, isRelaxedText, isFullRelaxedText, readerAttribute, onBlur, items} = this.props;
        let messageError = '';
        let selectedMenuItemValue;

        if (ContentUtils.isNull(isRequired)) {
            isRequired = true;
        }

        if (!isRequired) {
            this.setState({messageError: ''});
            return messageError === '';
        }

        if (this.state.selectedMenuItemIndex > 0) {
            selectedMenuItemValue = this._getSelectedMenuItemValue(readerAttribute);
            messageError = this._checkSelectedMenuItemValue(isFullRelaxedText, isRelaxedText, selectedMenuItemValue);
        } else {
            messageError = ContentUtils.isValidText(null, name);
        }

        if (additionalValidationFieldName) {
            const itemSelected = get(items, `${this.state.selectedMenuItemIndex - 1}`);
            const attributeValue = get(itemSelected, additionalValidationFieldName);
            if (!messageError && additionalValidation) {
                messageError = additionalValidation(attributeValue);
            }
        } else {
            if (!messageError && additionalValidation) {
                messageError = additionalValidation(selectedMenuItemValue);
            }
        }

        this.setState({messageError: messageError}, () => {
            if (onBlur) {
                onBlur(get(this.state, 'selectedMenuItem.itemModel'));
            }
        });
        return messageError === '';
    },

    _getSelectedMenuItemValue(readerAttribute, customReaderWriterAttribute) {
        const itemValue = this.props.items[this.state.selectedMenuItemIndex - 1];
        let itemModel;

        if (isStringOrIntegerItem(itemValue)) {
            itemModel = get(this.state, 'selectedMenuItem.itemModel');
        } else {
            const attribute = customReaderWriterAttribute || readerAttribute || 'text';
            itemModel = get(itemValue, attribute);
        }

        if (isStringOrIntegerItem(itemModel)) {
            // enter here means that current MenuItem is just simple text or number
            // which means that item model are the value it self
            return itemModel;
        } else {
            return get(itemModel, customReaderWriterAttribute || readerAttribute || 'text');
        }
    },

    _onChange(evt, index, menuItem) {
        this.setState({
            selectedMenuItem: menuItem,
            selectedMenuItemIndex: menuItem.payload
        });

        if (this.props.onChange) {
            this.props.onChange(evt, index, menuItem);
        }
    },

    _resolveIndex(menuItems) {
        let {value, readerAttribute, readerAttributeValue} = this.props;
        let selectedMenuItemIndex = get(this.state, 'selectedMenuItemIndex', 0);

        if (!value || this.state.resetSelection) {
            // enter here means that was trigger the clean of Dropdown, so reset their position
            // or just the `value` is not defined
            this.state.resetSelection = false;
            return selectedMenuItemIndex;
        }

        const safeReaderAttributeValue = readerAttributeValue || readerAttribute; // make optionally reader attribute value

        // Search the index of item that was defined by the consumer
        // from `selectedMenuItem` and assign the properly `index` position.
        const selectedMenuItemConsumer = find(menuItems, function (item, index) {
            item.index = index;
            // add item object in order to help to find properly index
            const itemModel = get(item, 'itemModel', item);
            const resultOne = getAttributeValue(itemModel, safeReaderAttributeValue);
            const resultTwo = getAttributeValue(value, safeReaderAttributeValue);

            return resultTwo !== undefined &&
                resultOne !== undefined &&
                resultOne === resultTwo;
        });

        const isValueChanged = selectedMenuItemConsumer && this.state.selectedMenuItemIndexConsumer != selectedMenuItemConsumer.index;

        if (isValueChanged) {
            // Enter here means that the consumer change the `value`
            // of drop down, this change came from out side of Drop
            // down component , generally from select another row of the table.
            this.state.selectedMenuItemIndexConsumer = selectedMenuItemConsumer.index;
            this.state.selectedMenuItemIndex = selectedMenuItemConsumer.index;
            this.state.selectedMenuItem = selectedMenuItemConsumer;
            return selectedMenuItemConsumer.index;
        } else {
            // Enter here means that was changed the Menu Item of the component
            // The change came from inside of drop down
            this.state.selectedMenuItem = get(this.state, 'selectedMenuItem');
            this.state.selectedMenuItemIndex = selectedMenuItemIndex;
            return selectedMenuItemIndex;
        }
    },

    _checkSelectedMenuItemValue(isFullRelaxedText, isRelaxedText, selectedMenuItemValue) {
        return isFullRelaxedText
        ? '' // empty string means is valid
        : isRelaxedText
        ? ContentUtils.isValidTextNotRequiredWithCustomValidation(selectedMenuItemValue, name, Constants.REGEX_NAME_RELAXED)
        : ContentUtils.isValidText(selectedMenuItemValue, name);
    },

    _setFocus(){
        this.setState({
            isFocus: true
        });
    },

    render() {
        const {isDisabled, items, isDark, isImmutable, isEditMode, name, readerAttribute} = this.props;

        const menuItems = buildItems(items, readerAttribute, name) || [];
        const indexValue = this._resolveIndex(menuItems);
        let dropdownClassName = 'form-group form-group-dropdown';

        if (isDark) {
            dropdownClassName += ' is-dark';
        }

        if (this.state.isFocus) {
            dropdownClassName += ' is-active';
        }

        const isDisabledInput = !!isDisabled || isImmutable && isEditMode;

        dropdownClassName += isDisabledInput ? ' is-disabled' : '';

        return (
            React.createElement("div", {className: dropdownClassName }, 
                React.createElement(SelectField, {
                    className: `form-group-dropdown-input`, 
                    ref: "dropdownEl", 
                    labelStyle: {color: '#fff', fontWeight: '300'}, 
                    onChange:  this._onChange, 
                    onEnterKeyDown: this.props.onEnter, 
                    onBlur:  this._updateWithOnBlurSelected.bind(this, this.isValid), 
                    onFocus: this._setFocus, 
                    floatingLabelStyle: {color: '#fff !important', fontWeight: '300'}, 
                    menuItems: menuItems, 
                    selectedIndex: indexValue, 
                    style: {width: '100%'}, 
                    errorText:  get(this.state, 'messageError', ''), 
                    disabled: isDisabledInput }
                )
            )
        );
    }
});

/**
 * Ask if given item is just text or an object. In case that is case, just
 * retrieve them. Otherwise retrieve the attribute value of given object.
 * @param item          {String | Object}
 * @param attribute     {String}
 * @return {string}
 */
function getAttributeValue(item, attribute) {
    return (typeof item === 'string' || typeof item === 'number') ? item : get(item, attribute);
}

function buildItems(items, readerAttribute, name) {
    if (get(items, 'length', 0) > 0) {
        if (isStringOrIntegerItem(items)) {
            return ComponentUtils.toMenuItemsText(items, name);
        } else {
            const nonSelectItem = [{payload: 0, text: `${t('select')} ${name}`}];
            return union(nonSelectItem, ComponentUtils.toMenuItems(items, readerAttribute, 'icon'));
        }
    } else {
        // return empty selected
        return [{payload: 0, text: `${t('select')} ${name}`}];
    }
}

/**
 * Check if given {@param value} if are string or number.
 * @param {Object || Array} value
 * @return {boolean}
 */
function isStringOrIntegerItem(value) {

    if (value === undefined || value === null) {
        return false;
    }

    return typeof value[0] === 'string' ||
        typeof value[0] === 'number' ||
        typeof value === 'number' ||
        typeof value === 'string';
}

module.exports = FormGroupDropdown;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown.jsx
 **/